import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ScrollReveal } from '../components/ui/ScrollReveal';
import { Button } from '../components/ui/Button';
export function ContactPage() {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Thank you for your inquiry. The PuttLab team will be in touch shortly.');
  };
  return <div className="w-full pt-24 bg-brand-cream-light min-h-screen" data-id="element-534">
      <div className="max-w-7xl mx-auto px-6 py-24" data-id="element-535">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-536">
          {/* Info Side */}
          <div className="lg:col-span-5" data-id="element-537">
            <ScrollReveal data-id="element-538">
              <SectionHeading eyebrow="Start a Project" title="Let's create something unforgettable." subtitle="Tell us about your space, your vision, and what kind of experience you want to build." data-id="element-539" />

              <div className="mt-16 space-y-8 font-body" data-id="element-540">
                <div data-id="element-541">
                  <h4 className="text-brand-gold font-bold uppercase tracking-widest text-xs mb-2" data-id="element-542">
                    Email
                  </h4>
                  <a href="mailto:hello@puttlabstudio.com" className="text-xl text-brand-green-deep hover:text-brand-gold transition-colors" data-id="element-543">
                    hello@puttlabstudio.com
                  </a>
                </div>
                <div data-id="element-544">
                  <h4 className="text-brand-gold font-bold uppercase tracking-widest text-xs mb-2" data-id="element-545">
                    Location
                  </h4>
                  <p className="text-xl text-brand-green-deep" data-id="element-546">
                    Toronto
                    <br data-id="element-547" />
                    <span className="text-brand-stone text-base" data-id="element-548">
                      Available for global projects
                    </span>
                  </p>
                </div>
              </div>
            </ScrollReveal>
          </div>

          {/* Form Side */}
          <div className="lg:col-span-7" data-id="element-549">
            <ScrollReveal delay={0.2} data-id="element-550">
              <form onSubmit={handleSubmit} className="bg-white p-8 md:p-12 rounded-sm shadow-xl border border-brand-stone/10" data-id="element-551">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-552">
                  <div data-id="element-553">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-554">
                      Name
                    </label>
                    <input type="text" required className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-555" />
                  </div>
                  <div data-id="element-556">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-557">
                      Company (Optional)
                    </label>
                    <input type="text" className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-558" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-559">
                  <div data-id="element-560">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-561">
                      Email
                    </label>
                    <input type="email" required className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-562" />
                  </div>
                  <div data-id="element-563">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-564">
                      Phone
                    </label>
                    <input type="tel" className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-565" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-566">
                  <div data-id="element-567">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-568">
                      Property Type
                    </label>
                    <select className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body appearance-none" data-id="element-569">
                      <option data-id="element-570">Residential</option>
                      <option data-id="element-571">Resort / Hotel</option>
                      <option data-id="element-572">Commercial Development</option>
                      <option data-id="element-573">Event / Activation</option>
                      <option data-id="element-574">Other</option>
                    </select>
                  </div>
                  <div data-id="element-575">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-576">
                      Budget Range
                    </label>
                    <select className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body appearance-none" data-id="element-577">
                      <option data-id="element-578">$10k - $25k</option>
                      <option data-id="element-579">$25k - $50k</option>
                      <option data-id="element-580">$50k - $100k</option>
                      <option data-id="element-581">$100k+</option>
                    </select>
                  </div>
                </div>

                <div className="mb-6" data-id="element-582">
                  <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-583">
                    Location (City, State/Prov)
                  </label>
                  <input type="text" required className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-584" />
                </div>

                <div className="mb-8" data-id="element-585">
                  <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-586">
                    Notes / Vision
                  </label>
                  <textarea rows={4} className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body resize-none" placeholder="Tell us about the space and what you're hoping to achieve..." data-id="element-587"></textarea>
                </div>

                <Button type="submit" variant="dark" className="w-full" data-id="element-588">
                  Submit Inquiry
                </Button>
              </form>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </div>;
}